<template>
  <div class="app-container">
    <!-- 搜索筛选区域 -->
    <div class="filter-container">
      <el-form inline size="small">
        <el-form-item label="丽呈酒店ID">
          <el-input
            v-model="listQuery.hotel_id"
            placeholder="精确查询"
            clearable
            style="width: 130px"
            type="number"
          />
        </el-form-item>
        <el-form-item label="房型ID">
          <el-input
            v-model="listQuery.id"
            placeholder="精确查询"
            clearable
            style="width: 130px"
          />
        </el-form-item>
        <el-form-item label="房型唯一编码">
          <el-input
            v-model="listQuery.roomtyp_id"
            placeholder="精确查询"
            clearable
            style="width: 130px"
          />
        </el-form-item>
        <el-form-item label="房型名称">
          <el-input
            v-model="listQuery.roomtyp_nm"
            placeholder="模糊查询"
            clearable
            style="width: 150px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleFilter">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
          <li-cheng-sync-button
            resource="room_type"
            label="同步指定酒店房型"
            @synced="getList"
          />
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      stripe
      size="small"
    >
      <el-table-column label="ID" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="API账号ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.api_account_id }}
        </template>
      </el-table-column>

      <el-table-column label="价格方案ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.price_plan_id }}
        </template>
      </el-table-column>

      <el-table-column label="丽呈酒店ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.hotel_id }}
        </template>
      </el-table-column>

      <el-table-column label="酒店编码" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.hotel_code }}
        </template>
      </el-table-column>

      <el-table-column label="房型ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.roomtyp_id }}
        </template>
      </el-table-column>

      <el-table-column label="房型名称" min-width="150" align="center">
        <template slot-scope="scope">
          {{ scope.row.roomtyp_nm }}
        </template>
      </el-table-column>

      <el-table-column label="房间面积" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.room_area || '-' }}
        </template>
      </el-table-column>

      <el-table-column label="最大入住人数" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.occupancy_max !== null ? scope.row.occupancy_max + '人' : '-' }}
        </template>
      </el-table-column>

      <el-table-column label="窗型" min-width="100" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.window_type === 101" type="success" size="mini">有窗</el-tag>
          <el-tag v-else-if="scope.row.window_type === 102" type="info" size="mini">无窗</el-tag>
          <el-tag v-else-if="scope.row.window_type === 103" type="warning" size="mini">部分有窗</el-tag>
          <el-tag v-else-if="scope.row.window_type === 104" type="danger" size="mini">内窗</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="状态" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.status }}
        </template>
      </el-table-column>

      <el-table-column label="同步时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.sync_at }}
        </template>
      </el-table-column>

      <el-table-column label="创建时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>

      <el-table-column label="更新时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.updated_at }}
        </template>
      </el-table-column>

      <el-table-column label="其他" min-width="80" align="center">
        <template slot-scope="scope">
          <span v-if="hasExtraData(scope.row)">...</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <!-- 操作列 -->
      <el-table-column label="操作" width="120" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="handleViewDetail(scope.row)"
          >
            查看详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 查看详情弹窗 -->
    <el-dialog
      title="房型详情"
      :visible.sync="dialogDetailVisible"
      width="800px"
      :close-on-click-modal="true"
    >
      <div class="detail-content">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="丽呈酒店ID">
            {{ currentRow.hotel_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="酒店编码">
            {{ currentRow.hotel_code || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="房型ID">
            {{ currentRow.roomtyp_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="房型名称">
            {{ currentRow.roomtyp_nm || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="房间面积">
            {{ currentRow.room_area || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="房间楼层">
            {{ currentRow.room_floors || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="最大入住人数">
            {{ currentRow.occupancy_max !== null ? currentRow.occupancy_max + '人' : '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="窗型">
            <el-tag v-if="currentRow.window_type === 101" type="success" size="mini">有窗</el-tag>
            <el-tag v-else-if="currentRow.window_type === 102" type="info" size="mini">无窗</el-tag>
            <el-tag v-else-if="currentRow.window_type === 103" type="warning" size="mini">部分有窗</el-tag>
            <el-tag v-else-if="currentRow.window_type === 104" type="danger" size="mini">内窗</el-tag>
            <span v-else>无</span>
          </el-descriptions-item>
          <el-descriptions-item label="状态">
            {{ currentRow.status || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="同步时间">
            {{ currentRow.sync_at || '无' }}
          </el-descriptions-item>
        </el-descriptions>

        <div class="json-section">
          <div class="json-label">床型列表：</div>
          <div v-if="currentRow.bed_type_list" class="json-content">
            <pre>{{ formatJson(currentRow.bed_type_list) }}</pre>
          </div>
          <div v-else class="json-empty">无</div>
        </div>

        <div class="json-section">
          <div class="json-label">图片列表：</div>
          <div v-if="currentRow.image_list" class="json-content">
            <pre>{{ formatJson(currentRow.image_list) }}</pre>
          </div>
          <div v-else class="json-empty">无</div>
        </div>

        <div class="json-section">
          <div class="json-label">原始JSON：</div>
          <div v-if="currentRawJson" class="json-content">
            <pre>{{ currentRawJson }}</pre>
          </div>
          <div v-else class="json-empty">无</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogDetailVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      // 搜索参数
      listQuery: {
        page: 1,
        limit: 10,
        hotel_id: undefined,
        id: undefined,
        roomtyp_id: undefined,
        roomtyp_nm: undefined,
        sort: 'id',
        order: 'DESC',
      },
      // 查看详情弹窗
      dialogDetailVisible: false,
      currentRow: {},
      currentRawJson: '',
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 判断是否有额外数据
    hasExtraData(row) {
      return row.room_floors || row.bed_type_list || row.image_list || row.raw_json
    },
    // 格式化JSON字符串
    formatJson(jsonStr) {
      if (!jsonStr) return ''
      try {
        const parsed = JSON.parse(jsonStr)
        return JSON.stringify(parsed, null, 2)
      } catch (e) {
        return jsonStr
      }
    },
    // 获取列表数据
    getList() {
      this.listLoading = true

      // 处理空值参数
      const params = {}
      Object.keys(this.listQuery).forEach((key) => {
        const val = this.listQuery[key]
        if (val !== '' && val !== undefined && val !== null) {
          params[key] = val
        }
      })

      request({
        url: '/api/backend/liCheng/hotel/roomTypeList',
        method: 'get',
        params: params,
      })
        .then((response) => {
          this.list = response.data.items
          this.total = response.data.total
          this.listLoading = false
        })
        .catch(() => {
          this.listLoading = false
        })
    },
    // 点击查询按钮
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    // 点击重置按钮
    handleReset() {
      this.listQuery = {
        page: 1,
        limit: 10,
        hotel_id: undefined,
        id: undefined,
        roomtyp_id: undefined,
        roomtyp_nm: undefined,
        sort: 'id',
        order: 'DESC',
      }
      this.getList()
    },
    // 每页显示数量变化
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    // 当前页码变化
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    // 查看详情
    handleViewDetail(row) {
      this.currentRow = Object.assign({}, row)
      if (row.raw_json) {
        try {
          const parsed = JSON.parse(row.raw_json)
          this.currentRawJson = JSON.stringify(parsed, null, 2)
        } catch (e) {
          this.currentRawJson = row.raw_json
        }
      } else {
        this.currentRawJson = ''
      }
      this.dialogDetailVisible = true
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.filter-container {
  margin-bottom: 10px;
}
.pagination-container {
  margin-top: 20px;
}
.detail-content {
  max-height: 500px;
  overflow: auto;
}
.json-section {
  margin-top: 15px;
  .json-label {
    font-weight: bold;
    margin-bottom: 8px;
  }
  .json-content {
    background-color: #f5f7fa;
    padding: 15px;
    border-radius: 4px;
    max-height: 150px;
    overflow: auto;
    pre {
      margin: 0;
      white-space: pre-wrap;
      word-wrap: break-word;
      font-size: 12px;
      line-height: 1.5;
      color: #333;
    }
  }
  .json-empty {
    text-align: center;
    padding: 15px;
    color: #999;
    background-color: #f5f7fa;
    border-radius: 4px;
  }
}
</style>
